"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addApi = addApi;
exports.empUpdateApi = empUpdateApi;
exports.exportEmpApi = exportEmpApi;
exports.exportUserFuCardInfo = exportUserFuCardInfo;
exports.listApi = listApi;
exports.updateApi = updateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 新增员工
 */
function addApi(data) {
  return (0, _request.default)({
    url: "/admin/customers/emp/add",
    method: 'POST',
    data: data
  });
}

/**
 * 修改员工
 */
function updateApi(data) {
  return (0, _requestMapi.default)({
    url: "/mapi/asset/customer-emp/update",
    method: 'PUT',
    data: data
  });
}

/**
 * 修改员工状态
 */
function empUpdateApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/emp/update/".concat(params.id, "/").concat(params.status),
    method: 'PUT'
  });
}

/**
 * 查询客户员工列表
 */
function listApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/asset/customer-emp/list",
    method: 'GET',
    params: params
  });
}

/**
 * 导出员工列表
 * @param {Number} customerIntegralId - 客户积分ID
 * @param {Object} params - 查询参数（与 listApi 相同）
 */
function exportEmpApi(customerIntegralId, params) {
  return (0, _request.default)({
    url: "/admin/customers/emp/export/".concat(customerIntegralId),
    method: 'GET',
    params: params
  });
}

/**
 * 导出员工列表
 * @param {Object} params - 查询参数（与 listApi 相同）
 */
function exportUserFuCardInfo(params) {
  return (0, _request.default)({
    url: "/admin/customers/emp/export/exportUserFuCardInfo",
    method: 'GET',
    params: params
  });
}